<template>
  <header class="InfoHeader">
    <span class="Title" :class="titleClass">{{ title }}</span>
    <actor-options v-if="selectedActor && hasManagerRights" />
  </header>
</template>

<script>
import ActorOptions from '@/components/landscape/info/ActorOptions'
import {mapGetters} from 'vuex'

export default {
  name: 'InfoHeader',
  components: {ActorOptions},
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'hasManagerRights']),
    titleClass() {
      return this.selectedActor && this.selectedActor.name ? '' : 'is-uppercase'
    }
  }
}
</script>

<style>
.InfoHeader {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  height: theme('height.header-section');
  z-index: theme('zIndex.headers');
  padding: 0 20px;
  background-color: theme('colors.gray.100');
  border-bottom: 1px solid theme('colors.gray.300');
  .Title {
    font-family: theme('fontFamily.mono');
    font-size: 14px;
    &.is-uppercase {
      text-transform: uppercase;
    }
  }
  @media (--desktop) {
    position: sticky;
    top: 0;
    padding: 0 24px;
  }
}
.ActorOptions {
  margin-left: auto;
}
</style>
